<template lang="html">
  <div class="monitor">
    <v-header :name="name" :isDashboard="true"></v-header>
    <div class="container">
      <div class="bottom">
        <div class="left">
          <div class="left-item left-item1">
            {{baseName}}
          </div>
          <div class="left-item">
            <p class="label">基地负责人</p>
            <p class="val">{{baseManager}}</p>
          </div>
          <div class="left-item">
            <p class="label">联系电话</p>
            <p class="val">{{contact}}</p>
          </div>
          <div class="left-item">
            <p class="label">基地面积</p>
            <p class="val">{{baseArea}}</p>
          </div>
        </div>
        
        <div class="middle">
          <div class="item">
            <v-lines></v-lines>
          </div>
          <div class="item">
            <v-line tit="无霜期"></v-line>
          </div>
          <div class="item">
            <v-lines3></v-lines3>
          </div>
          <div class="item">
            <v-lines4></v-lines4>
          </div>
        </div>

        <div class="right">
          <v-map @indexChange="indexChange"></v-map>
        </div>
      </div>
    </div>
     <!-- <div class="swiper-button-prev"  @click="prev"></div>
      <div class="swiper-button-next" @click="next"></div> -->
  </div>
</template>

<script>
import header from 'components/common/header'
import line from './components/line'
import lines from './components/lines'
import lines3 from './components/lines3'
import lines4 from './components/lines4'
import map from './components/map'
export default {
  data() {
    const that = this;
    return {
      name: '智慧种植',
      baseName: "",
      baseManager: "",
      contact: "",
      baseArea: "",
      timerIndustryInformation: null
    }
  },
  async  mounted() {
    let { err, res } = await this.$model('dataManagement').commonfn2(this.$apiUrl.DATAANALYSIS.Smartplanting);
    if (res.state === 200) {
      let resultData = JSON.parse(res.results)
      this.baseName = resultData.baseName
      this.baseManager = resultData.baseManager
      this.contact = resultData.contact
      this.baseArea = resultData.baseArea
    } else {
      this.$message.showError(err);
    }
    // this.timerIndustryInformation = setTimeout(() => {
    //   console.log("timerIndustryInformation")
    //   this.next()
    // }, 30000);
  },
  beforeDestroy() {
    clearInterval(this.timerIndustryInformation);
    this.timerIndustryInformation = null;
  },
  methods: {
    // 下标改变事件
    indexChange(newIndex) {
      this.activeItem = newIndex;
    },
    next() {
      this.$router.push('/rundatrace');
    },
    prev() {
      this.$router.push('/rundadashboard');
    }
  },
  components: {
    'v-header': header,
    'v-line': line,
    'v-lines': lines,
    'v-map': map,
    'v-lines3': lines3,
    'v-lines4': lines4
  }
}

</script>

<style lang="less" scoped>
.monitor {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background: url('../../../assets/img/common/bgNew2.png');
  background-size: 100% 100%;
}

.swiper-button-next {
  padding: -50px;
  position: absolute;
  z-index: 999;
  opacity: 1 !important;
  cursor: auto !important;
  pointer-events: auto !important;
}

.swiper-button-prev {
  opacity: 1 !important;
  cursor: auto !important;
  pointer-events: auto !important;
}

.container {
  width: 95%;
  height: 100%;
  margin: 0 auto;

  .area-list {
    display: flex;
    justify-content: center;

    .item {
      width: 12.6vh;
      height: 6vh;
      line-height: 6vh;
      text-align: center;
      background: url('../../../assets/img/industryInformation/word-bg.png') no-repeat;
      color: #fff;
      font-size: 2.2vh;
      margin-right: 2.9vh;
    }

    .active {
      background: url('../../../assets/img/industryInformation/word-bg1.png') no-repeat;
    }
  }

  .bottom {
    width: 100%;
    width: 100vw;
    height: 80vh;
    display: flex;
    // border: 1px solid red;

    .left {
      width: 12vw;
      flex-direction: column;
      color: #fff;
      font-size: 2vh;

      .left-item {
        width: 12vw;
        height: 18.6vh;
        background: url('../../../assets/img/industryInformation/detail-bg.png') no-repeat;
        background-size: 100% 100%;
        margin-bottom: 2vh;
        padding-left: 2vh;
        padding-top: 2vh;
        box-sizing: border-box;

        .label {
          color: #00A4FF;
          margin-bottom: 1vh;
        }

        .val {
          font-size: 1.6vh;
        }
      }

      .left-item1 {
        padding-top: 3.6vh;
        height: 18.5vh;
        background: url('../../../assets/img/industryInformation/tit-bg.png') no-repeat;
        background-size: 100% 100%;
        width: 12vw;
      }
    }

    .middle {
      width: 22.8vw;
      height: 80vh;
      // border: 1px green solid;
      .item {
        width: 20vw;
        height: 20.4vh;
        margin-left: 2.5vh;
        margin-bottom: 1.8vh;
        // border: 1px red solid;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?e7fefe1a